export default __webpack_public_path__ + "static/media/rotate.a67e4eae.svg";